var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetMulti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.375,
    height: 22.594
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bet-multi_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Rectangle_1072",
    "data-name": "Rectangle 1072",
    fill: "none",
    d: "M0 0h18.375v22.594H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bet-multi_svg__Icon_-_Bet_Multi",
    "data-name": "Icon - Bet Multi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bet-multi_svg__Group_2277",
    "data-name": "Group 2277",
    clipPath: "url(#bet-multi_svg__clip-path)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5542",
    "data-name": "Path 5542",
    d: "M17.625 21.844V2.157A1.407 1.407 0 0016.219.75H2.156A1.407 1.407 0 00.75 2.157v19.687l4.812-2.813 3.625 2.813 3.626-2.813z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5543",
    "data-name": "Path 5543",
    d: "M5.3 9.891a.352.352 0 110-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5544",
    "data-name": "Path 5544",
    d: "M5.3 9.891a.352.352 0 100-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5545",
    "data-name": "Path 5545",
    d: "M5.3 14.109a.352.352 0 110-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5546",
    "data-name": "Path 5546",
    d: "M5.3 14.109a.352.352 0 100-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5547",
    "data-name": "Path 5547",
    d: "M5.3 5.672a.352.352 0 110-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Path_5548",
    "data-name": "Path 5548",
    d: "M5.3 5.672a.352.352 0 100-.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Line_957",
    "data-name": "Line 957",
    transform: "translate(8.915 5.32)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h4.836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Line_958",
    "data-name": "Line 958",
    transform: "translate(8.915 9.539)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h4.836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bet-multi_svg__Line_959",
    "data-name": "Line 959",
    transform: "translate(8.915 13.758)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0 0h4.836"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgBetMulti as ReactComponent };